import { TokenState } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';

export const loginRevealButtonFunctions = {
  checkTokenState: (tokenState: TokenState, roundStartTime?: number) => {
    if (tokenState === TokenState.ValidToken) {
      if (!!roundStartTime && new Date().getTime() > roundStartTime) {
        return 'reveal-now';
      }
      return 'start-playing';
    }
    return 'log-in-to-reveal';
  }
};
